<script lang="ts" setup>

import IconVideo from '@lahaus-roomie/roomie/src/assets/icons/video-2.svg'
import type { Props } from './types'

const { t } = useI18n()

const props = withDefaults(defineProps<Props>(), {
  dataAttributes: {
    dataLh: { P: 'unknown', Z: 'unknown' }
  }
})

const emit = defineEmits(['openGallery'])

const showTourPart = props.listing.raw_listing?.attributes?.tour?.length > 0
const showVideoPart = props.listing.raw_listing?.attributes?.videos?.length > 0
const showWebinarPart = props.listing.ims?.webinars_urls?.length > 0

</script>

<script lang="ts">
export default {
  name: 'ExploreProjectSection'
}
</script>

<template>
  <section
    v-if="showTourPart || showVideoPart || showWebinarPart"
    class="explore-project-section mt-56">
    <div class="display-5 text-pine-600">
      {{ t('title') }}
    </div>

    <div class="flex flex-row gap-24 mt-40">
      <div
        v-if="showTourPart"
        class="part">
        <div
          v-lh-id="{...dataAttributes.dataLh, Z: t('title'), A: 'ver', C: t('tour_part')}"
          class="relative rounded-12 overflow-hidden cursor-pointer"
          @click="emit('openGallery', 'tours')">
          <img
            class="pointer-events-none"
            :src="props.listing.pictures_v2[0].url">

          <div class="pointer-events-none absolute top-0 left-0 w-full h-full bg-black opacity-40" />

          <div class="pointer-events-none flex absolute top-0 left-0 w-full h-full items-center justify-center">
            <IconVideo class="path w-24 h-24 fill-spring-600" />
          </div>
        </div>

        <div class="pointer-events-none hl-2-sb text-pine-600">
          {{ t('tour_part') }}
        </div>
      </div>

      <div
        v-if="showVideoPart"
        class="part">
        <div
          v-lh-id="{...dataAttributes.dataLh, Z: t('title'), A: 'ver', C: t('video_part')}"
          class="relative rounded-12 overflow-hidden cursor-pointer"
          @click="emit('openGallery', 'videos')">
          <img
            class="pointer-events-none"
            :src="props.listing.pictures_v2[1].url">

          <div class="pointer-events-none absolute top-0 left-0 w-full h-full bg-black opacity-40" />

          <div class="pointer-events-none flex absolute top-0 left-0 w-full h-full items-center justify-center">
            <IconVideo class="path w-24 h-24 fill-spring-600" />
          </div>
        </div>

        <div class="hl-2-sb text-pine-600">
          {{ t('video_part') }}
        </div>
      </div>

      <div
        v-if="showWebinarPart"
        class="part">
        <div
          v-lh-id="{...dataAttributes.dataLh, Z: t('title'), A: 'ver', C: t('webinar_part')}"
          class="relative rounded-12 overflow-hidden cursor-pointer"
          @click="emit('openGallery', 'webinars')">
          <img
            class="pointer-events-none"
            :src="props.listing.pictures_v2[2].url">

          <div class="pointer-events-none absolute top-0 left-0 w-full h-full bg-black opacity-40" />

          <div class="pointer-events-none flex absolute top-0 left-0 w-full h-full items-center justify-center">
            <IconVideo class="path w-24 h-24 fill-spring-600" />
          </div>
        </div>

        <div class="pointer-events-none hl-2-sb text-pine-600">
          {{ t('webinar_part') }}
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
.explore-project-section {
  margin-left: 13.1rem;
  margin-right: 13.1rem;

  .part {
    @apply flex flex-row rounded-24 p-24 gap-24 items-center;

    width: 32.3rem;
    height: 14.8rem;
    background: var(--color-gray-400);

    img {
      width: 10rem;
      height: 10rem;
    }

    svg {
      transform: scale(1.334);

      path {
        @apply fill-spring-600;
      }
    }
  }
}
</style>

<i18n src="./i18n.json" lang="json" />
